import * as ko from 'knockout'
import ObservableSubstitutePool from '@classic/Betting-v2/Model/Observables/ObservableSubstitutePool'
import template from './substitutes.tpl.html'
import { SubstitutesViewModel } from './SubstitutesViewModel'

if (!ko.components.isRegistered('substitutes-panel')) {
  ko.components.register('substitutes-panel', {
    viewModel: {
      createViewModel: (params: {
        availableSubstitutePools: ko.ObservableArray<ObservableSubstitutePool>
      }) => {
        const viewModel = new SubstitutesViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
